<template>
  <div class="mb-4">
    <div class="py-4  text-center">
      <h4 class="menu_heding _dynamic_text_color" :class="{ 'gradient_text_white': isGradient }">
        <Sparks />
        {{ botResponse?.component?.header || "Here's Some things you can do." }}
      </h4>
    </div>
    <div>
      <div class="start_up_buttons" v-if="serviceButtons && serviceButtons.length">
        <div v-for="(item, index) in serviceButtons" :key="item.id || index"
          :style="{ animationDelay: index * 0.1 + 's' }"
          class="bg-white _dynamic_bg_color  start_up_button_card animate-delay"
          :class="[{ custom_box_shadow: !isGradient }, { 'transparent-bg': isGradient }]"
          @click="onPayloadButtonClick($event, item)">
          <div class="custom-payload-con d-flex align-items-center flex-column justify-content-center">
            <div :title="item.text" class="cursor-pointer icon_container _dynamic_text_color"
              :disabled="isWaitingForResponse">
              <!-- <em
                :class="['primaryicon-' + iconMap(item.image), item.icon == 'primaryicon-Sales-Special' ? 'customfontsize' : '', { 'gradient_text_white': isGradient }]" /> -->
              <component :is="item.image" :theme-color="isGradient ? '#fff' : '#B3B3B3'" />

            </div>
            <p class="m-0 _theme_font_bold _dynamic_text_color" :class="{ 'gradient_text_white': isGradient }">
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>
      <!-- <div>
          <div @click="openTextUs()"
            class="d-flex align-items-center bg-white flex-column shadow-sm  start_up_button_card custom-payload-con  ">
            <TextUsIcon height="25" width="25" :theme-color="chatThemeSettings?.borderColor" />
            <div class="icon_container">
              <em class="primaryicon-mobile" :style="{ color: chatThemeSettings?.borderColor || '#000' }" />
            </div>

            <span class="_theme_font_bold"> {{ customizedFlowNameForTextUs }} </span>
          </div>
        </div> -->
    </div>

    <div v-if="showModal">
      <div id="viewDetailsModal" class="modal" :style="{ display: showModal ? 'block' : 'none' }"
        style="overflow: auto">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header align-items-center">
              <h6 class="m-0 _theme_font_bold">Text Us</h6>
              <div>
                <button type="button" aria-label="Close" class="close" @click.prevent="showModal = false">
                  ×
                </button>
              </div>
            </div>
            <div class="p-3">
              <TextusForm />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop show" />
    </div>
  </div>
</template>
<script>
import TextusForm from '../../TextusForm/TextusForm.vue';
import TvmStartUpButtons from '../../TvmStartUpButtons/TvmStartUpButtons.js';
import Sparks from '../Icons/Sparks.vue';
import BuyAVehicle from "../StartUpIcons/BuyAVehicle.vue";
import FindAVehicle from "../StartUpIcons/FindAVehicle.vue";
import GetPreQualified from "../StartUpIcons/GetPreQualified.vue";
import Models from "../StartUpIcons/Models.vue";
import Mobile from "../StartUpIcons/Mobile.vue";
import ReserveAVehicle from "../StartUpIcons/ReserveAVehicle.vue";
import SalesSpecial from "../StartUpIcons/SalesSpecial.vue";
import ScheduleService from "../StartUpIcons/ScheduleService.vue";
import SellUsYourVehicle from "../StartUpIcons/SellUsYourVehicle.vue";
import ServiceCoupons from "../StartUpIcons/ServiceCoupons.vue";
import ValueYourTrade from "../StartUpIcons/ValueYourTrade.vue";
import ScheduleTestDrive from "../StartUpIcons/ScheduleTestDrive.vue";

export default {
  mixins: [TvmStartUpButtons],
  data() {
    return {
      showModal: false,
      isTextUsEnabled: window.isTextUsEnabled,
    };
  },
  methods: {
    openTextUs() {
      this.showModal = true;
    },
    iconMap(icon) {
      if (icon == 'Mobile') {
        return 'mobile';
      }
      return icon;
    },
  },
  components: {
    TextusForm,
    Sparks,
    'buy-a-vehicle': BuyAVehicle,
    'find-a-vehicle': FindAVehicle,
    'Get-Pre-Qualified': GetPreQualified,
    'Models': Models,
    'Mobile': Mobile,
    'Reserve-a-vehicle': ReserveAVehicle,
    'Sales-Special': SalesSpecial,
    'Schedule-Service': ScheduleService,
    'Sell-Us-Your-Vehicle': SellUsYourVehicle,
    'Service-Coupons': ServiceCoupons,
    'Value-Your-Trade': ValueYourTrade,
    'Schedule-Test-Drive': ScheduleTestDrive,
  },
  mounted() {

  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },

}
</script>
<style>
@media (min-width: 1920px) and (max-width: 2399px) {
  .ask_ai .start_up_buttons :deep(p) {
    font-size: 16px;
  }

  .ask_ai .menu_heding {
    font-size: 35px;
  }
}

.ask_ai .menu_heding {
  font-weight: bold;
}

.start_up_buttons {
  gap: 15px;
  /* max-width: 1000px; */
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.start_up_button_card {
  border-radius: 11px;
  padding: 20px 10px;
}

.start_up_button_card em {
  font-size: 26px;
}

.start_up_button_card:hover {
  cursor: pointer;
  /* transform: scale(1.1, 1.1);
  transition: all 0.5s ease-in; */
}

.custom-payload-con .icon_container {
  /* border: 1px solid #eee; */
  /* border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center; */
  margin: 10px 0;
}

.animate-delay {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: animate-delay;
}

@keyframes animate-delay {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
